
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15181.65 17028.35 11.298 13.301"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_198_6","data-name":"Symbol 198 – 6","transform":"translate(6534 889)","opacity":".64"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3669","d":"M7 2a10.3 10.3 0 0 0-4.223.84A1.357 1.357 0 0 0 2 4.068v7.842a1.389 1.389 0 0 0 .776 1.25A10.226 10.226 0 0 0 7 14","data-name":"Path 3669","transform":"translate(-21717 16138)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3670","d":"M25.2 2a10.226 10.226 0 0 1 4.223.84 1.365 1.365 0 0 1 .777 1.25v7.82a1.389 1.389 0 0 1-.776 1.25A10.226 10.226 0 0 1 25.2 14","data-name":"Path 3670","transform":"translate(-21735.201 16138)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3672","d":"M2 33.7a9.192 9.192 0 0 0 5 1.271 9.139 9.139 0 0 0 5-1.271","data-name":"Path 3672","transform":"translate(-21717 16113.129)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3671","d":"M2 15.9a9.192 9.192 0 0 0 5 1.271 9.139 9.139 0 0 0 5-1.271","data-name":"Path 3671","transform":"translate(-21717 16127.095)"}})])])
          )
        }
      }
    